import React from "react";
import "./ConstruccionCivil.css"; 
import electronicaImg from "../assets/images/electronica.jpg";
import pdfMalla from "../assets/docs/electronica.pdf";
import { FaMicrochip, FaDownload } from "react-icons/fa";

const ElectronicaIndustrial = () => {
  return (
    <section className="carrera-detalle">
      {/* Banner  */}
      <div
        className="carrera-hero-modern"
        style={{ backgroundImage: `url(${electronicaImg})` }}
      >
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Electrónica Industrial</h1>
          <p>
            Formamos profesionales técnicos en control, automatización y
            mantenimiento electrónico industrial.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
     
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaMicrochip className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN ELECTRÓNICA INDUSTRIAL
              </h3>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIA GENERAL</h5>
              <p>
                Planificar, organizar, diseñar, supervisar y ejecutar la
                construcción, montaje, instalación y mantenimiento de sistemas
                electrónicos relacionados al control de procesos industriales,
                aplicando normas de calidad, seguridad industrial y preservación
                del medio ambiente.
              </p>

              <h5 className="fw-bold text-primary mt-4">
                CAMPOS DE ACCIÓN EN LOS QUE SE INSERTAN LOS EGRESADOS
              </h5>
              <p>
                El profesional técnico en Electrónica Industrial planifica,
                organiza, dirige, ejecuta, analiza y controla los sistemas
                electrónicos en aplicaciones y plantas industriales,
                laboratorios, talleres e instituciones educativas, siguiendo
                normas de seguridad y calidad establecidas.
              </p>

              <h5 className="fw-bold text-primary mt-4">PUESTOS DE TRABAJO</h5>
              <ul>
                <li>Supervisor de plantas con sistemas eléctricos</li>
                <li>Instructor técnico</li>
                <li>Especialista en automatización electrónica</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">
                SALIDA HACIA OTROS ESTUDIOS
              </h5>
              <ul>
                <li>Ingeniería de Sistemas</li>
                <li>Ingeniería Mecatrónica</li>
                <li>Ingeniería Electrónica</li>
                <li>Ingeniería Industrial</li>
              </ul>
            </div>
          </div>

          {/* Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img
                src={electronicaImg}
                alt="Electrónica Industrial"
                className="img-fluid rounded-3 mb-3"
              />
              <a
                href={pdfMalla}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-download w-100"
              >
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024
                (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">
                  Seis semestres equivalentes a tres años académicos.
                </p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno - 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno - 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElectronicaIndustrial;
